module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-menu-node",
    class: {
      'is-opened': _vm.opened
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.opened = !_vm.opened
      }
    }
  }, [_c('div', {
    staticClass: "el-menu-node-content",
    style: ({
      'padding-left': (_vm.level - 1) * 10 + 'px'
    })
  }, [_c('span', {
    staticClass: "el-menu-node-icon",
    class: _vm.node.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "el-menu-node-text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.menuClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.node.text))]), _vm._v(" "), _c('span', {
    staticClass: "el-menu-node-opened-icon ",
    class: {
      'el-icon-arrow-down': _vm.hasChild
    }
  })]), _vm._v(" "), _c('collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "el-menu-node-children"
  }, _vm._l((_vm.node.children), function(child) {
    return _c('el-menu-item', {
      attrs: {
        "node": child,
        "level": _vm.level + 1
      }
    })
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8eb359e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/src/menu-node.vue
// module id = 665
// module chunks = 0